import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export const ActionBlockedDialog = ({ message, onClose }) => (
  <Dialog open={!!message} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-md" data-testid="action-blocked-dialog">
      <DialogHeader><DialogTitle className="font-display">Action Blocked</DialogTitle></DialogHeader>
      <p className="text-sm text-muted-foreground" data-testid="action-blocked-message">{message}</p>
      <DialogFooter>
        <Button onClick={onClose} data-testid="action-blocked-ok">OK</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

let _last = { msg: null, at: 0 };
export const showBlocked = (msg) => window.dispatchEvent(new CustomEvent("daa-action-blocked", { detail: msg }));

// A blocked message already shown in the dialog must not also appear as a toast.
const _origError = toast.error;
toast.error = (m, o) => (m && _last.msg && Date.now() - _last.at < 3000 && String(m).includes(_last.msg) ? undefined : _origError(m, o));

export const ActionBlockedHost = () => {
  const [msg, setMsg] = useState(null);
  useEffect(() => {
    const on = (e) => { _last = { msg: e.detail, at: Date.now() }; setMsg(e.detail); };
    window.addEventListener("daa-action-blocked", on);
    return () => window.removeEventListener("daa-action-blocked", on);
  }, []);
  return <ActionBlockedDialog message={msg} onClose={() => setMsg(null)} />;
};
